import { init, captureException, browserTracingIntegration, replayIntegration } from '@sentry/react';
import {
  NoPermissionError,
  OauthTokenError,
  PasswordError,
  UserNotAuthenticatedError,
} from '@extrahorizon/javascript-sdk';
import { ElementNotFoundError } from 'services/errors/ElementNotFoundError';
import { NetworkError } from 'services/errors/NetworkError';
import { AxiosError } from 'axios';
import { NoStaffError } from 'services/errors/NoStaffError';
import { appVersion, environment, isLocal, targetHost } from './app';
import { displayNotificationError } from './notifications';

export const initSentry = () => {
  if (isLocal) return;

  init({
    release: appVersion,
    dsn: 'https://491537261ef8320c79adb5f8023e90c8@o412939.ingest.sentry.io/4506619638251520',
    environment,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [targetHost],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};

export const handleQueryError = (error: Error) => {
  if (
    error instanceof NetworkError ||
    error instanceof UserNotAuthenticatedError ||
    error instanceof ElementNotFoundError ||
    error instanceof NoPermissionError ||
    error instanceof OauthTokenError ||
    error instanceof AxiosError ||
    error instanceof PasswordError ||
    error instanceof NoStaffError
  ) {
    return;
  }

  displayNotificationError({ error });

  if (isLocal) {
    console.error(' ! THIS ERROR LOG WILL SEND TO SENTRY !', error);
    return;
  }
  captureException(error);
};
